export interface BookData {
  id: string;
  title: string;
  author: string;
  description: string;
  category: 'manifestation' | 'motivational';
  coverUrl: string;
  amazonUrl: string;
}

export const books: BookData[] = [
  {
    id: '1',
    title: 'Atomic Habits',
    author: 'James Clear',
    description: 'A practical guide to building good habits and breaking bad ones, emphasizing small changes for significant results.',
    category: 'motivational',
    coverUrl: 'https://images-na.ssl-images-amazon.com/images/P/0735211299.01.L.jpg',
    amazonUrl: 'https://amzn.to/3SK5EXW'
  },
  {
    id: '2',
    title: 'The Secret',
    author: 'Rhonda Byrne',
    description: 'Explores the law of attraction and how positive thinking can shape one\'s life.',
    category: 'manifestation',
    coverUrl: 'https://images-na.ssl-images-amazon.com/images/P/1582701709.01.L.jpg',
    amazonUrl: 'https://amzn.to/4kVLXIz'
  },
  {
    id: '3',
    title: 'The Power of Positive Thinking',
    author: 'Norman Vincent Peale',
    description: 'A classic that emphasizes the importance of faith and optimism in achieving success.',
    category: 'motivational',
    coverUrl: 'https://images-na.ssl-images-amazon.com/images/P/0743234804.01.L.jpg',
    amazonUrl: 'https://amzn.to/4mUgAjx'
  },
  {
    id: '4',
    title: 'The Power of Now',
    author: 'Eckhart Tolle',
    description: 'Encourages living in the present moment to find true happiness and enlightenment.',
    category: 'motivational',
    coverUrl: 'https://images-na.ssl-images-amazon.com/images/P/1577314808.01.L.jpg',
    amazonUrl: 'https://amzn.to/3Zn4Wnb'
  },
  {
    id: '5',
    title: 'Think and Grow Rich',
    author: 'Napoleon Hill',
    description: 'A foundational text on personal development and wealth-building through focused desire and persistence.',
    category: 'motivational',
    coverUrl: 'https://images-na.ssl-images-amazon.com/images/P/1585424331.01.L.jpg',
    amazonUrl: 'https://amzn.to/3Zn4XaJ'
  },
  {
    id: '6',
    title: 'You Are a Badass',
    author: 'Jen Sincero',
    description: 'A candid and humorous guide to self-improvement and embracing one\'s inner greatness.',
    category: 'motivational',
    coverUrl: 'https://images-na.ssl-images-amazon.com/images/P/0762447699.01.L.jpg',
    amazonUrl: 'https://amzn.to/43FDSlO'
  },
  {
    id: '7',
    title: 'Year of Yes',
    author: 'Shonda Rhimes',
    description: 'A memoir detailing the transformative power of saying "yes" to opportunities and challenges.',
    category: 'motivational',
    coverUrl: 'https://images-na.ssl-images-amazon.com/images/P/1476777098.01.L.jpg',
    amazonUrl: 'https://amzn.to/4ktGHfu'
  },
  {
    id: '8',
    title: 'Big Magic',
    author: 'Elizabeth Gilbert',
    description: 'Delves into the mysteries of creativity and how to live a fulfilling creative life.',
    category: 'motivational',
    coverUrl: 'https://images-na.ssl-images-amazon.com/images/P/1594634726.01.L.jpg',
    amazonUrl: 'https://amzn.to/3FNLI3x'
  },
  {
    id: '9',
    title: 'The Four Agreements',
    author: 'Don Miguel Ruiz',
    description: 'Offers a code of conduct based on ancient Toltec wisdom to achieve personal freedom.',
    category: 'motivational',
    coverUrl: 'https://images-na.ssl-images-amazon.com/images/P/1878424319.01.L.jpg',
    amazonUrl: 'https://amzn.to/3ZWAO29'
  },
  {
    id: '10',
    title: 'The Power of Habit',
    author: 'Charles Duhigg',
    description: 'Explores the science behind habit formation and how to harness it for personal and professional success.',
    category: 'motivational',
    coverUrl: 'https://images-na.ssl-images-amazon.com/images/P/081298160X.01.L.jpg',
    amazonUrl: 'https://amzn.to/3ZWAOPH'
  },
  {
    id: '11',
    title: 'The Magic',
    author: 'Rhonda Byrne',
    description: 'Focuses on gratitude as a powerful tool for manifesting desires.',
    category: 'manifestation',
    coverUrl: 'https://images-na.ssl-images-amazon.com/images/P/1451673442.01.L.jpg',
    amazonUrl: 'https://amzn.to/4kwkDRn'
  },
  {
    id: '12',
    title: 'Manifest',
    author: 'Roxie Nafousi',
    description: 'A modern guide to manifestation, blending personal development with actionable steps.',
    category: 'manifestation',
    coverUrl: 'https://images-na.ssl-images-amazon.com/images/P/1788172027.01.L.jpg',
    amazonUrl: 'https://amzn.to/4mQtUFL'
  },
  {
    id: '13',
    title: 'You Can Heal Your Life',
    author: 'Louise Hay',
    description: 'Explores the connection between mind and body, emphasizing the power of affirmations and positive thinking.',
    category: 'manifestation',
    coverUrl: 'https://images-na.ssl-images-amazon.com/images/P/0937611018.01.L.jpg',
    amazonUrl: 'https://amzn.to/3FIkbAy'
  },
  {
    id: '14',
    title: 'Journey Beyond Selene',
    author: 'Jeffrey Kluger',
    description: 'A transformative guide to manifestation and personal growth beyond conventional boundaries.',
    category: 'manifestation',
    coverUrl: 'https://images-na.ssl-images-amazon.com/images/P/0684847655.01.L.jpg',
    amazonUrl: 'https://amzn.to/4490hrI'
  },
  {
    id: '15',
    title: 'The 7 Habits of Highly Effective People',
    author: 'Stephen R. Covey',
    description: 'A comprehensive guide to personal and professional effectiveness through principle-centered living.',
    category: 'motivational',
    coverUrl: 'https://images-na.ssl-images-amazon.com/images/P/1982137274.01.L.jpg',
    amazonUrl: 'https://amzn.to/4dS9DeG'
  },
  {
    id: '16',
    title: 'Mindset',
    author: 'Carol S. Dweck',
    description: 'Explores the power of mindset in achieving success and overcoming challenges.',
    category: 'motivational',
    coverUrl: 'https://images-na.ssl-images-amazon.com/images/P/0345472322.01.L.jpg',
    amazonUrl: 'https://amzn.to/4mTQlJZ'
  },
  {
    id: '17',
    title: 'The Alchemist',
    author: 'Paulo Coelho',
    description: 'A philosophical novel about following your dreams and listening to your heart.',
    category: 'motivational',
    coverUrl: 'https://images-na.ssl-images-amazon.com/images/P/0062315005.01.L.jpg',
    amazonUrl: 'https://amzn.to/45URcUy'
  },
  {
    id: '18',
    title: 'Ask and It Is Given',
    author: 'Esther and Jerry Hicks',
    description: 'Teachings from Abraham about the law of attraction and emotional guidance.',
    category: 'manifestation',
    coverUrl: 'https://images-na.ssl-images-amazon.com/images/P/1401904599.01.L.jpg',
    amazonUrl: 'https://amzn.to/4dWLF22'
  },
  {
    id: '19',
    title: 'The Law of Attraction',
    author: 'Esther and Jerry Hicks',
    description: 'The basic teachings of Abraham about attracting what you want into your life.',
    category: 'manifestation',
    coverUrl: 'https://images-na.ssl-images-amazon.com/images/P/1401912273.01.L.jpg',
    amazonUrl: 'https://amzn.to/4e5MAx5'
  },
  {
    id: '20',
    title: 'Money, and the Law of Attraction',
    author: 'Esther and Jerry Hicks',
    description: 'Learning to attract wealth, health, and happiness through the law of attraction.',
    category: 'manifestation',
    coverUrl: 'https://images-na.ssl-images-amazon.com/images/P/1401918816.01.L.jpg',
    amazonUrl: 'https://amzn.to/4kYhZ6H'
  },
  {
    id: '21',
    title: 'Daring Greatly',
    author: 'Brené Brown',
    description: 'How the courage to be vulnerable transforms the way we live, love, parent, and lead.',
    category: 'motivational',
    coverUrl: 'https://images-na.ssl-images-amazon.com/images/P/1592408419.01.L.jpg',
    amazonUrl: 'https://amzn.to/3HxB4yp'
  },
  {
    id: '22',
    title: 'The Gifts of Imperfection',
    author: 'Brené Brown',
    description: 'Let go of who you think you\'re supposed to be and embrace who you are.',
    category: 'motivational',
    coverUrl: 'https://images-na.ssl-images-amazon.com/images/P/159285849X.01.L.jpg',
    amazonUrl: 'https://amzn.to/4kRmJey'
  },
  {
    id: '23',
    title: 'The 3 Choices',
    author: 'Jorge Cruise',
    description: 'Transform your life through powerful decision-making and conscious choice.',
    category: 'manifestation',
    coverUrl: 'https://images-na.ssl-images-amazon.com/images/P/1401946070.01.L.jpg',
    amazonUrl: 'https://amzn.to/4kYvH9S'
  },
  {
    id: '24',
    title: 'The Anomaly Mind-Set',
    author: 'Sandi Krakowski',
    description: 'Breaking through conventional thinking to achieve extraordinary results.',
    category: 'manifestation',
    coverUrl: 'https://images-na.ssl-images-amazon.com/images/P/1401956459.01.L.jpg',
    amazonUrl: 'https://amzn.to/43O1LGp'
  },
  {
    id: '25',
    title: 'The Untethered Soul',
    author: 'Michael A. Singer',
    description: 'The journey beyond yourself to find inner peace and spiritual freedom.',
    category: 'motivational',
    coverUrl: 'https://images-na.ssl-images-amazon.com/images/P/1572245379.01.L.jpg',
    amazonUrl: 'https://amzn.to/3FSShBJ'
  }
];